import React from "react";
import {
  ArrowUpRightCircle,
  Eye,
  Folder,
  Pin,
  Image,
  Upload,
} from "react-bootstrap-icons";
import { getAppChoicesFromKey, getSortedCountyValues } from "./global";
import { ADMIN_ROLE, STATUS } from "./constants";

export const getLabelsByRole = (location, appChoices, role) => {
  // this
  const getCountyMapLinks = (appChoices) => {
    const counties = appChoices.find((a) => a.key === "County")?.values || [];

    const links = {};
    counties.forEach((c) => {
      links[c["county"]] = {
        Appr: c["appraisalLink"],
        "Appr Map": c["appraisalMapLink"],
      };
    });

    return links;
  };

  const allLabels = [
    {
      key: "propertyAddress",
      label: "Property Address",
      shortLabel: "Property Addr",
      type: "text",
      category: "input",
      width: 80,
      sticky: true,
    },
    {
      key: "propertyStreet",
      label: "Property Street Name",
      shortLabel: "Property Str",
      type: "text",
      category: "input",
      width: 80,
      sticky: true,
    },
    {
      key: "folder",
      label: "Folder",
      category: "url",
      width: 50,
      icon: (job) => {
        return <Folder size={14} className="align-text-top" />;
      },
      valueModifier: (job) => generateLinkForDrive(job),
    },
    {
      key: "appr",
      label: "Appr",
      category: "url",
      width: 50,
      icon: (job) => {
        return <ArrowUpRightCircle size={14} className="align-text-top" />;
      },
      valueModifier: (job) =>
        generateLinkForAppr(job, getCountyMapLinks(appChoices)),
    },
    {
      key: "apprMap",
      label: "Appr Map",
      category: "url",
      width: 50,
      icon: (job) => (
        <ArrowUpRightCircle size={14} className="align-text-top" />
      ),
      valueModifier: (job) =>
        generateLinkForApprMap(job, getCountyMapLinks(appChoices)), // this
    },
    {
      key: "apprImage",
      label: "Appr Image",
      category: "url",
      width: 50,
      icon: (job) => {
        return job["appraisalImageId"] ? (
          <Image size={14} className="align-text-top" />
        ) : (
          <Upload size={14} className="align-text-top" />
        );
      },
      valueModifier: (job) => generateLinkForApprImage(job),
    },
    {
      key: "googleMap",
      label: "Google Map",
      category: "url",
      width: 50,
      icon: (job) => <Pin size={14} className="align-text-top" />,
      valueModifier: (job) => generateLinkForGoogleMap(job),
    },
    {
      key: "view",
      label: "View",
      category: "url",
      width: 50,
      icon: (job) => <Eye size={14} className="align-text-top" />,
      valueModifier: (job) => linkForView(job),
    },
    {
      key: "status",
      label: "Status",
      type: "dropdown",
      category: "input",
      options: STATUS,
      width: 70,
    },
    {
      key: "waitingForQuote",
      label: "Waiting For Quote",
      category: "text",
      width: 70,
      valueModifier: (job) => {
        return calculateQuoteRequestReceivedTime(job["createdAt"]);
      },
    },
    {
      key: "contractStatus",
      label: "Contract Status",
      category: "text",
      width: 70,
      valueModifier: (job) => job["contractStatus"],
    },
    {
      key: "typeOfLandSurvey",
      label: "Type of Land Survey",
      type: "dropdown",
      category: "input",
      width: 70,
    },
    { key: "city", label: "City", type: "text", category: "input", width: 50 },
    {
      key: "proposedDueDate",
      label: "Proposed Due Date",
      type: "date",
      category: "input",
      width: 100,
    },
    {
      key: "titleClosingDate",
      label: "Title Closing Date",
      type: "date",
      category: "input",
      width: 100,
    },
    {
      key: "agreedDueDate",
      label: "Agreed Due Date",
      type: "date",
      category: "input",
      width: 100,
    },
    {
      key: "acreage",
      label: "Acreage",
      type: "number",
      category: "input",
      width: 60,
    },
    {
      key: "comment",
      label: "Comment",
      type: "text",
      category: "input",
      width: 80,
    },
    {
      key: "requestCommit",
      label: "Request Commit",
      type: "checkbox",
      category: "input",
      width: 60,
    },
    {
      key: "floodZoneCheck",
      label: "Flood Zone Check",
      type: "checkbox",
      category: "input",
      width: 60,
    },
    {
      key: "requestDeeds",
      label: "Request Deeds",
      type: "checkbox",
      category: "input",
      width: 60,
    },
    {
      key: "invoiceSent",
      label: "Invoice Sent",
      type: "checkbox-date",
      category: "input",
      width: 60,
    },
    {
      key: "invoicePaid",
      label: "Invoice Paid",
      type: "checkbox-date",
      category: "input",
      width: 60,
    },
    {
      key: "closingMinusAgreedDueDate",
      label: "Closing minus agreed due date",
      shortLabel: "Closing - agr. due date",
      category: "text",
      width: 50,
      valueModifier: (job) =>
        calculateNumberOfDays(job["agreedDueDate"], job["titleClosingDate"]),
    },
    {
      key: "closingMinusProposedDueDate",
      label: "Closing minus proposed due date",
      shortLabel: "Closing - prop. due date",
      category: "text",
      width: 50,
      valueModifier: (job) =>
        calculateNumberOfDays(job["proposedDueDate"], job["titleClosingDate"]),
    },
    {
      key: "daysUntilClosing",
      label: "Days until closing",
      category: "text",
      width: 50,
      valueModifier: (job) =>
        calculateNumberOfDays(
          new Date().toISOString(),
          job["titleClosingDate"]
        ),
    },
    {
      key: "clientPriority",
      label: "Client Priority",
      type: "dropdown",
      category: "input",
      width: 65,
    },
    {
      key: "value",
      label: "Value",
      type: "number",
      category: "input",
      width: 50,
    },
    {
      key: "fieldTime",
      label: "Field Time",
      type: "number",
      category: "input",
      width: 50,
    },
    {
      key: "draftingTime",
      label: "Drafting Time",
      type: "number",
      category: "input",
      width: 60,
    },
    {
      key: "reviewingTime",
      label: "Reviewing Time",
      type: "number",
      category: "input",
      width: 70,
    },
    {
      key: "isThereAClosing",
      label: "Is there a closing?",
      type: "checkbox",
      category: "input",
      width: 70,
    },
    {
      key: "latitude",
      label: "Latitude",
      type: "text",
      category: "input",
      width: 70,
      validator: (value) => {
        const validRegex = /^-?\d+(\.\d+)?$/;
        const isValid = !value || value === "-" || validRegex.test(value);
        return { isValid, message: !isValid && "Invalid Latitude" };
      },
    },
    {
      key: "longitude",
      label: "Longitude",
      type: "text",
      category: "input",
      width: 70,
      validateOnChange: true,
      validator: (value) => {
        const validRegex = /^-?\d+(\.\d+)?$/;
        const isValid = !value || value === "-" || validRegex.test(value);
        return {
          isValid,
          message: !isValid && "Invalid Longitude",
        };
      },
    },
    {
      key: "fieldStaff",
      label: "Field Staff",
      type: "dropdown",
      category: "input",
      width: 70,
    },
    {
      key: "draftsman",
      label: "Draftsman",
      type: "dropdown",
      category: "input",
      width: 70,
    },
    {
      key: "reviewer",
      label: "Reviewer",
      type: "dropdown",
      category: "input",
      width: 70,
    },
    {
      key: "county",
      label: "County",
      type: "dropdown",
      category: "input",
      width: 50,
    },
    {
      key: "propertyAppraisalId",
      label: "Property Appraisal ID",
      type: "text",
      category: "input",
      width: 70,
    },
    {
      key: "dueDateMet",
      label: "Due date met?",
      category: "text",
      width: 70,
      valueModifier: (job) => calculateDueDateMet(job["agreedDueDate"]),
    },
    {
      key: "woodedPercent",
      label: "Wooded percent",
      type: "number",
      category: "input",
      width: 60,
      max: 1,
      min: 0,
    },
    {
      key: "creekLength",
      label: "Creek length",
      type: "number",
      category: "input",
      width: 60,
    },
    {
      key: "subDivisionAge",
      label: "Subdivision age",
      type: "number",
      category: "input",
      width: 70,
    },
    {
      key: "difficulty",
      label: "Difficulty",
      type: "dropdown",
      category: "input",
      width: 70,
    },
    {
      key: "distanceToPropertyInHours",
      label: "Distance to property in hours",
      type: "number",
      category: "input",
      width: 70,
    },
    {
      key: "urgent",
      label: "Urgent",
      type: "checkbox",
      category: "input",
      width: 50,
    },
    {
      key: "subDivision",
      label: "Subdivision",
      type: "text",
      category: "input",
      width: 70,
    },
    { key: "lot", label: "Lot", type: "text", category: "input", width: 50 },
    {
      key: "block",
      label: "Block",
      type: "text",
      category: "input",
      width: 50,
    },
    {
      key: "abstract",
      label: "Abstract",
      type: "text",
      category: "input",
      width: 70,
    },
    {
      key: "abstractNumber",
      label: "Abstract Number",
      type: "text",
      category: "input",
      width: 70,
    },
  ];

  if (!location.pathname.includes("quoting")) {
    allLabels.splice(
      allLabels.findIndex((obj) => obj.label === "Waiting For Quote"),
      1
    );
  }

  const columnsWithOptions = allLabels?.map((lb) => {
    if (lb?.options) {
      return lb;
    }
    if (lb?.label === "Client Priority") {
      const priorityOptions = getAppChoicesFromKey(appChoices, lb?.label);
      const reorderedPriorityOptions = priorityOptions
        .filter((client) => client === "Random Client")
        .concat(priorityOptions.filter((client) => client !== "Random Client"));

      return {
        ...lb,
        options: reorderedPriorityOptions,
      };
    } else if (lb?.label === "County") {
      return {
        ...lb,
        options: getSortedCountyValues(appChoices),
      };
    }
    return { ...lb, options: [...getAppChoicesFromKey(appChoices, lb?.label)] };
  });

  if (role === ADMIN_ROLE) return columnsWithOptions;

  const excludedLabelsByRole = {
    Manager: [],
    Draftsman: ["Value"],
    "Field Staff": ["Value"],
  };

  return columnsWithOptions.filter(
    (lb) => !excludedLabelsByRole[role]?.includes(lb.label)
  );
};

// input,url,text

const generateLinkForAppr = (job, mapLinks) => {
  if (
    mapLinks &&
    mapLinks[job["county"]] &&
    mapLinks[job["county"]]["Appr"] && // this
    job["propertyAppraisalId"]
  ) {
    return mapLinks[job["county"]]["Appr"].replace(
      "{{appraisalId}}",
      job["propertyAppraisalId"]
    );
  }
  return null;
};
const generateLinkForApprMap = (job, mapLinks) => {
  if (
    mapLinks &&
    mapLinks[job["county"]] &&
    mapLinks[job["county"]]["Appr Map"] &&
    job["propertyAppraisalId"]
  ) {
    return mapLinks[job["county"]]["Appr Map"].replace(
      "{{appraisalId}}",
      job["propertyAppraisalId"]
    );
  }
  return null;
};
const generateLinkForApprImage = (job) => {
  if (job["appraisalImageId"]) {
    return `https://drive.google.com/file/d/${job["appraisalImageId"]}/view`;
  } else return null;
};
const generateLinkForGoogleMap = (job) => {
  if (job["latitude"] && job["latitude"]) {
    return `https://maps.google.com/?q=${job["latitude"]},${job["longitude"]}`;
  } else return null;
};
const generateLinkForDrive = (job) => {
  if (job["driveFolder"]) {
    return `https://drive.google.com/drive/folders/${job["driveFolder"]}`;
  }
  return null;
};
const linkForView = (job) => {
  if (job["_id"]) return `/job/${job["_id"]}`;
  return null;
};

export const calculateNumberOfDays = (date1, date2) => {
  if (!date1 || !date2) return "N/A";
  const date1Date = new Date(date1);
  date1Date.setHours(0);
  date1Date.setMinutes(0);
  date1Date.setSeconds(0);
  date1Date.setMilliseconds(0);

  const date2Date = new Date(date2);
  date2Date.setHours(0);
  date2Date.setMinutes(0);
  date2Date.setSeconds(0);
  date2Date.setMilliseconds(0);

  const diffTime = date2Date.getTime() - date1Date.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
const calculateDueDateMet = (jobDueDate) => {
  if (!jobDueDate) return "N/A";
  const dueDate = new Date(jobDueDate);
  dueDate.setHours(0);
  dueDate.setMinutes(0);
  dueDate.setSeconds(0);
  dueDate.setMilliseconds(0);

  return getTodayMidnight().getTime() >= dueDate.getTime() ? "YES" : "NO";
};

const getTodayMidnight = () => {
  const dateNow = new Date();
  dateNow.setHours(0);
  dateNow.setMinutes(0);
  dateNow.setSeconds(0);
  dateNow.setMilliseconds(0);

  return dateNow;
};

export const calculateQuoteRequestReceivedTime = (submittionDate) => {
  const dateNow = new Date();
  if (!submittionDate) return "N/A";

  const dueDate = new Date(submittionDate);
  const diffTime = dateNow.getTime() - dueDate.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60));
};
